import {
  Share2,
  Navigation,
  UtensilsCrossed,
  UserCircle,
  Mail,
  Phone,
  Store,
  ChefHat,
  Sandwich,
  MapPinned,
  ShieldCheck,
  Wallet,
  LocateFixed,
  XCircle,
  FileText,
  Heart,
  ShoppingBag,
  Star,
  Tag,
  Route,
  CalendarClock,
  IndianRupee,
  LayoutDashboard,
  MapPin,
  UserPlus,
  ClipboardList,
  CreditCard,
  Percent,
  Receipt,
  Bell,
  Contact,
  Ban,
  type LucideIcon,
} from "lucide-react";

export type FdFeatureIcon =
  | "social-login"
  | "order-navigation"
  | "book-table"
  | "profile"
  | "email-sms"
  | "call"
  | "find-restaurants"
  | "cuisine-search"
  | "food-search"
  | "area-search"
  | "otp"
  | "wallet"
  | "track-order"
  | "cancel-order"
  | "invoice"
  | "favourite"
  | "place-order"
  | "reviews"
  | "offers"
  | "navigation-guide"
  | "scheduled-booking"
  | "live-navigation"
  | "earnings"
  | "dashboard"
  | "spot-booking"
  | "merchant-registration"
  | "order-management"
  | "payment-management"
  | "commission"
  | "invoice-handling"
  | "ratings"
  | "social-settings"
  | "notifications"
  | "contact-details"
  | "cancelled-orders";

export const fdFeatureIconMap: Record<FdFeatureIcon, LucideIcon> = {
  "social-login": Share2,
  "order-navigation": Navigation,
  "book-table": UtensilsCrossed,
  profile: UserCircle,
  "email-sms": Mail,
  call: Phone,
  "find-restaurants": Store,
  "cuisine-search": ChefHat,
  "food-search": Sandwich,
  "area-search": MapPinned,
  otp: ShieldCheck,
  wallet: Wallet,
  "track-order": LocateFixed,
  "cancel-order": XCircle,
  invoice: FileText,
  favourite: Heart,
  "place-order": ShoppingBag,
  reviews: Star,
  offers: Tag,
  "navigation-guide": Route,
  "scheduled-booking": CalendarClock,
  "live-navigation": Navigation,
  earnings: IndianRupee,
  dashboard: LayoutDashboard,
  "spot-booking": MapPin,
  "merchant-registration": UserPlus,
  "order-management": ClipboardList,
  "payment-management": CreditCard,
  commission: Percent,
  "invoice-handling": Receipt,
  ratings: Star,
  "social-settings": Share2,
  notifications: Bell,
  "contact-details": Contact,
  "cancelled-orders": Ban,
};
